import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { fadeIn } from 'utils/style/animations';

export const NOTIFICATION_CARD_WIDTH = 15;
export const NOTIFICATION_CARD_WIDTH_DESKTOP = 17;

export const Container = styled(Link)<{
  $isVisible: boolean;
  $idx: number;
}>`
  display: flex;
  scroll-snap-align: center;
  flex-direction: column;
  height: 12.5rem;
  flex-shrink: 0;
  overflow: hidden;
  width: ${NOTIFICATION_CARD_WIDTH}rem;
  background-color: ${Styles.color.white};
  border-radius: 8px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  transition: 0.25s;
  opacity: 0;
  animation: ${fadeIn} 0.5s ${p => 0.15 * p.$idx}s forwards;
  ${p =>
    p.$isVisible &&
    css`
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    `}
  ${Styles.desktop`
      box-shadow: unset;
      scroll-snap-align: unset;
      width: ${NOTIFICATION_CARD_WIDTH_DESKTOP}rem;
      height: 13.95rem;
    `};
`;

export const ImageContainer = styled(Picture)`
  flex: 1 0;
  border-radius: 0;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  padding: 0.6rem 0.75rem;
  width: 100%;
`;

export const TitleText = styled.h2`
  font-size: 1rem;
  font-weight: bold;
  color: ${Styles.color.black};
  margin: 0;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  ${Styles.desktop`
    font-size: 1.1rem;
    line-height: 1.5;
  `}
`;

export const DescriptionTextBlock = styled(SanityBlockRenderer)`
  font-size: 0.75rem;
  color: #777777;

  ${Styles.desktop`
    font-size: 0.8rem;
  `}
`;

export const TitleAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  width: 91%;
  align-self: flex-start;
`;

export const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0.1rem;
  flex-shrink: 0;
  svg {
    fill: ${Styles.color.black};
  }
`;

export const Wrapper = styled.div`
  display: flex;
`;
